import React from "react"
import { Row, Col } from 'antd';
import './style.scss'

const arrs = [
    {name:'Dawn Song',con:'UC Berkeley',type:"F",img:'https://img.alicdn.com/imgextra/i1/O1CN01JtH3MJ1LuSuRCPtuN_!!6000000001359-2-tps-300-300.png',link:'https://people.eecs.berkeley.edu/~dawnsong'},
    {name:'Bo Li',con:'UIUC',type:"F",img:'https://img.alicdn.com/imgextra/i2/O1CN01l9oVgf1tYCajbjR4o_!!6000000005913-2-tps-300-300.png',link:'https://aisecure.github.io'},
    // {name:'David Forsyth',con:'UIUC',type:"F",img:'https://img.alicdn.com/imgextra/i1/O1CN01YprdiJ1YREdRop09r_!!6000000003055-2-tps-300-300.png',link:'http://luthuli.cs.uiuc.edu/~daf'},
    {name:'Jun Zhu',con:'Tsinghua University',type:"F",img:'https://img.alicdn.com/imgextra/i2/O1CN01Fcec3e1MkDfD0OaQK_!!6000000001472-2-tps-300-300.png',link:'http://ml.cs.tsinghua.edu.cn/~jun/index.shtml'},
    {name:'Hang Su',con:'Tsinghua University',type:"F",img:'https://img.alicdn.com/imgextra/i3/O1CN01Ngz5ZP1Mw7xd83Bdk_!!6000000001498-2-tps-300-300.png',link:'https://www.suhangss.me'},
    {name:'Hui Xue',con:'Alibaba Group',type:"F",img:'https://img.alicdn.com/imgextra/i1/O1CN01TmwKak1lSEVIoNBAw_!!6000000004817-2-tps-300-300.png',link:'https://www.linkedin.com/in/hui-xue-68916784/?originalSubdomain=cn'},
    {name:'Yuan He',con:'Alibaba Group',type:"F",img:'https://img.alicdn.com/imgextra/i1/O1CN01YENVxT1HRNHsMokKk_!!6000000000754-2-tps-300-300.png',link:'https://scholar.google.com/citations?user=cWbXLzgAAAAJ&hl=zh-CN'},
    {name:'Xinyun Chen',con:'UC Berkeley',type:"S",img:'https://img.alicdn.com/imgextra/i1/O1CN01uhIPZd24ZXWFKohdT_!!6000000007405-2-tps-300-300.png',link:'https://jungyhuk.github.io'},
    {name:'Fan Wu',con:'UIUC',type:"S",img:'https://aisecure.github.io/GROUP/files/Fan_Wu.jpg',link:'https://kkkkahlua.github.io'},
    {name:'Chulin Xie',con:'UIUC',type:"S",img:'https://img.alicdn.com/imgextra/i4/O1CN01ZBrP3N1cWy3VYs64v_!!6000000003609-2-tps-300-300.png',link:'https://alphapav.github.io'},
    {name:'Boxin Wang',con:'UIUC',type:"S",img:'https://aisecure.github.io/GROUP/files/boxin.jpeg',link:'https://wbx.life/'},
    {name:'Yinpeng Dong',con:'Tsinghua University',type:"S",img:'https://aisecure-workshop.github.io/amlcvpr2021/imgs/yinpeng.jpeg',link:'http://ml.cs.tsinghua.edu.cn/~yinpeng/'},
    {name:'Qi-An Fu',con:'Tsinghua University',type:"S",img:'https://aisecure-workshop.github.io/amlcvpr2021/imgs/qa.jpg',link:'https://scholar.google.com/citations?user=qdxQNxEAAAAJ&hl=en'},
]

export default function Organizers() {
    return <div className="page-organizers">
            <div className="organizers-title">Organizers
                <div>
                    <span className="Faculty">Faculty Organizers</span>
                    <span className="Student">Student Organizers</span>
                </div>
                
            </div>
            <Row className="list-ul">
                {arrs.map((item, index) => (<Col xl={4} sm={12} span={24} key={index} className="list-li"> 
                    <div className="list-two" onClick={() => { window.open(item.link) }}>
                        <img src={item.img} alt="" />
                        <div className="pro-div">
                            <span>{item.name}</span>
                            <b className={item.type === "F" ? "b" : ''} />
                            <div>
                                <div  dangerouslySetInnerHTML = {{__html : item.con}} />
                                {item.type==="F" ? <div id="Faculty">Faculty Organizers</div> : <div id="Student">Student Organizers</div>}
                            </div>
                        </div>
                    </div>
                </Col>))}
            </Row>
        </div>
}
